import { formatApplication } from "./Application";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAssignableApplications } from "./ApplicationProvider";
import { MuiRhfAutocompleteListField } from "../../shared/components/forms/MuiRhfAutocompleteListField";

export function ApplicationSelectField(props: {
  name: string,
  disabled?: boolean
}) {
  const {t} = useTranslation();
  const applications = useAssignableApplications();

  return (
    <MuiRhfAutocompleteListField
      name={props.name}
      label={t('User.applicationRoles.application')}
      list={applications}
      getListLabel={(application) => formatApplication(application) || ''}
      getListKey={(application) => application.id!!}
      disabled={props.disabled}
    />
  )
}
